import ToolbarDivider from '~/components/toolbar/shared/ToolbarDivider';
import BoxZoomTool from '~/components/toolbar/tools/BoxZoomTool';
import ContouringTools from '~/components/toolbar/tools/ContouringTools';
import PanTool from '~/components/toolbar/tools/PanTool';
import ResetViewTool from '~/components/toolbar/tools/ResetViewTool';
import UndoRedoTool from '~/components/toolbar/tools/UndoRedoTool';

export default function ContouringStepTools() {
    return (
        <>
            <PanTool />
            <BoxZoomTool />
            <ResetViewTool />
            <ToolbarDivider />
            <ContouringTools />
            <ToolbarDivider />
            <UndoRedoTool />
        </>
    );
}
